import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  EnumResponse,
  SearchQuery,
  SearchQueryAware,
  SearchResponse,
  ApplicationWithUnconfirmedEmailOtpResponse
} from '@backoffice-monorepo/api';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { ErrorsService } from './errors.service';

@Injectable({
  providedIn: 'root'
})
export class ApplicationWithoutConfirmedOtpService extends BaseService implements SearchQueryAware<ApplicationWithUnconfirmedEmailOtpResponse> {

  constructor(
    protected http: HttpClient,
    protected errorsService: ErrorsService
  ) {
    super(http, errorsService);
  }
  listEnumValues(enumClass: string): Observable<EnumResponse> {
    throw new Error('Method not implemented.');
  }

  find(searchQuery: SearchQuery): Observable<SearchResponse<ApplicationWithUnconfirmedEmailOtpResponse>> {
    return this.post(`/api/loan-applications/list-with-unconfirmed-otp`, searchQuery);
  }
}
